/** Sneaker / apparel brands available in @thesvg/react for Ari demos */
export type AriBrandId = "nike" | "adidas" | "newbalance" | "jordan" | "mcdonalds";

const BRAND_ALIASES: Record<string, AriBrandId> = {
  nike: "nike",
  adidas: "adidas",
  newbalance: "newbalance",
  nb: "newbalance",
  jordan: "jordan",
  "jordan brand": "jordan",
  mcdonalds: "mcdonalds",
  "mcdonald's": "mcdonalds",
};

const BRAND_KEYWORDS: Array<{ pattern: RegExp; id: AriBrandId }> = [
  { pattern: /\bnew\s*balance\b/i, id: "newbalance" },
  { pattern: /\bjordan\s*brand\b/i, id: "jordan" },
  { pattern: /\badidas\b/i, id: "adidas" },
  { pattern: /\bnike\b/i, id: "nike" },
  { pattern: /\bmcdonald'?s?\b/i, id: "mcdonalds" },
  { pattern: /\bivy\s*park\b/i, id: "adidas" },
];

export function resolveAriBrandId(...sources: Array<string | undefined | null>): AriBrandId | null {
  for (const raw of sources) {
    if (!raw) continue;
    const normalized = raw.trim().toLowerCase();
    const direct = BRAND_ALIASES[normalized];
    if (direct) return direct;

    for (const { pattern, id } of BRAND_KEYWORDS) {
      if (pattern.test(raw)) return id;
    }
  }
  return null;
}
